module.exports = __webpack_public_path__ + "static/img/nice-number.e5b9e6a3.jpg";